export const scrollToTop = () => {
  const clientWidth = document.documentElement.clientWidth
  if (clientWidth < 992) {
    const content = document.getElementsByClassName('layout__content')
    if (content[0]) {
      content[0].scrollTop = 0
    }
  } else {
    window.scrollTo(0, 0)
  }
}

export const scrollToBottom = () => {
  const clientWidth = document.documentElement.clientWidth
  if (clientWidth < 992) {
    const content = document.getElementsByClassName('layout__content')
    if (content[0]) {
      content[0].scrollTop = content[0].scrollHeight
    }
  } else {
    window.scrollTo(0, document.body.scrollHeight)
  }
}
